import { Inject, Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './AuthService';

@Injectable()
export class AuthGuardService  {
    constructor(private _router: Router, @Inject(AuthService) private authService: AuthService) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const role = route.data.role;
        return this.authService.checkRouting(role);
    }
}
